var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DAppGroup',{attrs:{"list":_vm.dapps},scopedSlots:_vm._u([{key:"item",fn:function(item){return [_c('DAppCard',{attrs:{"dapp":item.data}})]}}])},[_c('template',{slot:"title"},[_vm._t("title")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c62981b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/DAppCardGroup.vue
// module id = null
// module chunks = 